//     "crud_organizations", //CRUD les organisations [DONE]
//     "crud_sites", //CRUD les sites [DONE]
//     "view_site_calendar", //Voir les calendriers des sites [DONE]
//     "crud_event_calendar", //CRUD les évènements sur les calendrier des sites [DONE]
//     "view_recipients", //Voir la liste des allocataires [DONE]
//     "update_recipients", //Modifier les infos des allocataires [DONE]
//     "unlock_recipient", //Débloquer le compte [DONE]
//     "resend_recipient_activation", //Renvoyer le lien d'activation [DONE]
//     "report_recipient_appointments", //Reporter les RDVS des allocataires [DONE]
//     "view_recipients_temp", //Voir la liste des allocataires temporaires [DONE]
//     "send_rdsp_link", //Envoyer le lien de la RDO [DONE]
//     "crud_users", //CRUD utilisateur [DONE]
//     "manager_appointments", //Traiter des rendez-vous [DONE]
//     "view_anomalies", //Voir les anomalies [DONE]
//     "assign_anomaly", //Assigner une anomalie [DONE]
//     "manage_anomalies", //Voir et traiter mes anomalies [DONE]
//     "modify_constants", //Modifier les constantes dynamiques [DONE]
//     "crud_operateurs", //CRUD opérateurs [DONE]
//     "crud_themes", //CRUD thèmes [DONE]
//     "use_simulator", //Faire une simulation [DONE]
//     "create_simulator_rdsp", //Assigner le résultat d'une simulation à un allocataire [DONE]
//     "modify_rdsp", //modifier un RDO [DONE]
//     "create_rdsp", //créer un RDO [DONE]
//     "cron_anomaly", //lancer le cron des anomalies [DONE]
//     "file_exchange", //gérer les échanges de fichiers plats [DONE]
//     "view_sites", //Voir la liste des site (pour CSU uniquement)
//     "view_rdsp", //voir les RDO d'un allocataire
//     "view_stats", //voir les stats
//     "create_recipient", //créer un allocataire
//     "view_passorientation", //voir le passorientation
//     "export_csv", //exporter des données en csv
//     "remove_anomaly" //supprimer une anomalie [DONE]
//     "edit_ep", //voir et éditer les EP
//     "create_recipient_ep" //créer un alloc man. pour EP
//     "finalize_ep", //"finaliser une EP"
//      "crud_reorientations" //liste des réorientations en cours
//     "edit_ep_details", //voir et éditer le détail EP
//     "manage_ep_invitations" // gérer les invitations EP
//      "view_ar_mail" // voir l'état des AR
//      "download_ar_mail" // télécharger des AR
//      "view_ep_calendar" //voir le calendrier des EP
//      "view_imports" //voir le suivi et le rejeu des imports (ADMIN et SUPER_ADMIN uniquement)
//      "view_sanctions_ft" //voir les propositions de sanction France Travail (ADMIN et SUPER_ADMIN uniquement)
//      "view_exports" //voir le suivi des exports et en demander (ADMIN et SUPER_ADMIN uniquement)
//      "download_exports" //télécharger le fichier d'un export depuis sa page (ADMIN et SUPER_ADMIN uniquement)
//      "delete_exports" //supprimer manuellement un export et son fichier (SUPER_ADMIN uniquement)
//      "view_regles_orientation" //voir les règles de sous-orientation et leur historique (ADMIN et SUPER_ADMIN uniquement, CE-1419)
//      "edit_regles_orientation" //saisir les règles de sous-orientation et préparer une version (SUPER_ADMIN uniquement, CE-1419)
//      "view_sous_orientation" //voir la sous-orientation sur le dossier ; la correction suit les choix renvoyés par l'API (agents Caf, encadrement, administrateurs, CE-1370)

// Comptes d'opérateur d'accompagnement (CE-1407) : tout est masqué sauf la
// liste des sites, le calendrier d'un site et la gestion de ses créneaux. Le
// périmètre (sa structure seulement) est porté par le rôle, voir
// helpers/perimetreOperateur.js et visibiliteMenu.filtrerMenu.
const privilegesMasquesOperateur = [
  "manager_appointments",
  "view_recipients",
  "update_recipients",
  "unlock_recipient",
  "resend_recipient_activation",
  "view_recipient_appointments",
  "report_recipient_appointments",
  "view_recipients_temp",
  "view_recipients_stock",
  "view_recipient_stock",
  "export_recipient_stock",
  "send_rdsp_link",
  "view_rdsp",
  "modify_rdsp",
  "create_rdsp",
  "create_recipient",
  "create_simulator_rdsp",
  "use_simulator",
  "view_passorientation",
  "view_stats",
  "crud_reorientations",
  "crud_users",
  "crud_organizations",
  "crud_sites",
  "crud_operateurs",
  "crud_themes",
  "view_anomalies",
  "assign_anomaly",
  "manage_anomalies",
  "remove_anomaly",
  "cron_anomaly",
  "modify_constants",
  "file_exchange",
  "export_csv",
  "edit_ep",
  "create_recipient_ep",
  "finalize_ep",
  "edit_ep_details",
  "modify_epdetails",
  "manage_ep_invitations",
  "view_ar_mail",
  "download_ar_mail",
  "view_ep_calendar",
  "view_sectors",
  "view_imports",
  "view_sanctions_ft",
  "view_exports",
  "download_exports",
  "delete_exports",
  "crud_cer",
  "view_cer_list",
  "view_regles_orientation",
  "edit_regles_orientation",
  "view_sous_orientation",
];

const roleConfig = {
  ADMIN: [
    "delete_exports", //Supprimer manuellement un export (SUPER_ADMIN uniquement)
    "view_recipients_stock", //Voir la liste des allocataires stock [DONE]
    "create_rdsp", //créer un RDO [DONE]
    "edit_regles_orientation", //Saisir les règles de sous-orientation (SUPER_ADMIN uniquement, CE-1419)
  ],
  SUPER_ADMIN: [
    "view_recipients_stock", //Voir la liste des allocataires stock [DONE]
  ],
  CAF_DIRECTOR: [
    "delete_exports", //Supprimer manuellement un export (SUPER_ADMIN uniquement)
    "crud_organizations", //CRUD les organisations [DONE]
    "crud_sites", //CRUD les sites [DONE]
    "crud_users", //CRUD utilisateur [DONE]
    "view_imports", //Voir le suivi des imports [DONE]
    "view_sanctions_ft", //Voir les propositions de sanction France Travail [DONE]
    "view_exports", //Voir le suivi des exports et en demander [DONE]
    "download_exports", //Télécharger le fichier d'un export [DONE]
    "modify_constants", //Modifier les constantes dynamiques [DONE]
    "view_recipients_stock", //Voir la liste des allocataires stock [DONE]
    "crud_operateurs", //CRUD opérateurs [DONE]
    "crud_themes", //CRUD thèmes [DONE]
    "cron_anomaly", //lancer le cron des anomalies [DONE]
    "file_exchange", //gérer les échanges de fichiers plats [DONE]
    "remove_anomaly", //supprimer une anomalie [DONE]
    "view_sectors", //voir et éditer les secteurs,
    "create_rdsp", //créer un RDO [DONE]

    "create_recipient_ep", //créer un alloc man. pour EP
    "modify_epdetails", //modifier les paramètres d'un EP
    "crud_reorientations",
    "manage_ep_invitations",
    "view_recipient_stock", //voir la liste des alloc du stock
    "export_recipient_stock", //exporter la liste des alloc du stock
    "view_regles_orientation", //Voir les règles de sous-orientation (ADMIN et SUPER_ADMIN uniquement, CE-1419)
    "edit_regles_orientation", //Saisir les règles de sous-orientation (SUPER_ADMIN uniquement, CE-1419)
  ],
  MANAGER: [
    "delete_exports", //Supprimer manuellement un export (SUPER_ADMIN uniquement)
    "crud_organizations", //CRUD les organisations [DONE]
    "crud_sites", //CRUD les sites [DONE]
    "crud_users", //CRUD utilisateur [DONE]
    "view_imports", //Voir le suivi des imports [DONE]
    "view_sanctions_ft", //Voir les propositions de sanction France Travail [DONE]
    "view_exports", //Voir le suivi des exports et en demander [DONE]
    "download_exports", //Télécharger le fichier d'un export [DONE]
    "modify_constants", //Modifier les constantes dynamiques [DONE]
    "view_recipients_stock", //Voir la liste des allocataires stock [DONE]
    "crud_operateurs", //CRUD opérateurs [DONE]
    "crud_themes", //CRUD thèmes [DONE]
    "cron_anomaly", //lancer le cron des anomalies [DONE]
    "file_exchange", //gérer les échanges de fichiers plats [DONE]
    "remove_anomaly", //supprimer une anomalie [DONE]
    "view_sectors", //voir et éditer les secteurs,
    "create_recipient_ep", //créer un alloc man. pour EP
    "finalize_ep", //"finaliser une EP"
    "view_recipient_stock", //voir la liste des alloc du stock
    "export_recipient_stock", //exporter la liste des alloc du stock
    "create_rdsp", //créer un RDO [DONE]
    "view_regles_orientation", //Voir les règles de sous-orientation (ADMIN et SUPER_ADMIN uniquement, CE-1419)
    "edit_regles_orientation", //Saisir les règles de sous-orientation (SUPER_ADMIN uniquement, CE-1419)
  ],
  AGENT_CAF_TS: [
    "delete_exports", //Supprimer manuellement un export (SUPER_ADMIN uniquement)
    "crud_organizations", //CRUD les organisations [DONE]
    "crud_sites", //CRUD les sites [DONE]
    "crud_users", //CRUD utilisateur [DONE]
    "view_imports", //Voir le suivi des imports [DONE]
    "view_sanctions_ft", //Voir les propositions de sanction France Travail [DONE]
    "view_exports", //Voir le suivi des exports et en demander [DONE]
    "download_exports", //Télécharger le fichier d'un export [DONE]
    "view_anomalies", //Voir les anomalies [DONE]
    "assign_anomaly", //Assigner une anomalie [DONE]
    "modify_constants", //Modifier les constantes dynamiques [DONE]
    "view_recipients_stock", //Voir la liste des allocataires stock [DONE]
    "crud_operateurs", //CRUD opérateurs [DONE]
    "crud_themes", //CRUD thèmes [DONE]
    "cron_anomaly", //lancer le cron des anomalies [DONE]
    "file_exchange", //gérer les échanges de fichiers plats [DONE]
    "crud_event_calendar",
    "remove_anomaly", //supprimer une anomalie [DONE]
    "view_sectors", //voir et éditer les secteurs,
    "create_recipient_ep", //créer un alloc man. pour EP
    "finalize_ep", //"finaliser une EP"
    "modify_epdetails", //modifier les paramètres d'un EP
    "manage_ep_invitations",
    "view_recipient_stock", //voir la liste des alloc du stock
    "export_recipient_stock", //exporter la liste des alloc du stock
    "create_rdsp", //créer un RDO [DONE]
    "view_regles_orientation", //Voir les règles de sous-orientation (ADMIN et SUPER_ADMIN uniquement, CE-1419)
    "edit_regles_orientation", //Saisir les règles de sous-orientation (SUPER_ADMIN uniquement, CE-1419)
  ],
  AGENT_CAF_EG: [
    "delete_exports", //Supprimer manuellement un export (SUPER_ADMIN uniquement)
    "crud_organizations", //CRUD les organisations [DONE]
    "crud_sites", //CRUD les sites [DONE]
    "crud_users", //CRUD utilisateur [DONE]
    "view_imports", //Voir le suivi des imports [DONE]
    "view_sanctions_ft", //Voir les propositions de sanction France Travail [DONE]
    "view_exports", //Voir le suivi des exports et en demander [DONE]
    "download_exports", //Télécharger le fichier d'un export [DONE]
    "view_anomalies", //Voir les anomalies [DONE]
    "assign_anomaly", //Assigner une anomalie [DONE]
    "modify_constants", //Modifier les constantes dynamiques [DONE]
    "view_recipients_stock", //Voir la liste des allocataires stock [DONE]
    "crud_operateurs", //CRUD opérateurs [DONE]
    "crud_themes", //CRUD thèmes [DONE]
    "cron_anomaly", //lancer le cron des anomalies [DONE]
    "file_exchange", //gérer les échanges de fichiers plats [DONE]
    "crud_event_calendar",
    "remove_anomaly", //supprimer une anomalie [DONE]
    "view_sectors", //voir et éditer les secteurs,
    "create_recipient_ep", //créer un alloc man. pour EP
    "finalize_ep", //"finaliser une EP"
    "modify_epdetails", //modifier les paramètres d'un EP
    "manage_ep_invitations",
    "crud_cer",
    "view_cer_list",
    "view_recipient_stock", //voir la liste des alloc du stock
    "export_recipient_stock", //exporter la liste des alloc du stock
    "crud_reorientations",
    "view_ep_calendar",
    "view_recipients_temp",
    "view_regles_orientation", //Voir les règles de sous-orientation (ADMIN et SUPER_ADMIN uniquement, CE-1419)
    "edit_regles_orientation", //Saisir les règles de sous-orientation (SUPER_ADMIN uniquement, CE-1419)
  ],
  AGENT_CSU_CDD: [
    "delete_exports", //Supprimer manuellement un export (SUPER_ADMIN uniquement)
    "crud_organizations", //CRUD les organisations [DONE]
    "crud_sites", //CRUD les sites [DONE]
    "view_site_calendar", //Voir les calendriers des sites [DONE]
    "crud_event_calendar", //CRUD les évènements sur les calendrier des sites [DONE]
    "crud_users", //CRUD utilisateur [DONE]
    "view_imports", //Voir le suivi des imports [DONE]
    "view_sanctions_ft", //Voir les propositions de sanction France Travail [DONE]
    "view_exports", //Voir le suivi des exports et en demander [DONE]
    "download_exports", //Télécharger le fichier d'un export [DONE]
    "manager_appointments", //Traiter des rendez-vous [DONE]
    "view_anomalies", //Voir les anomalies [DONE]
    "assign_anomaly", //Assigner une anomalie [DONE]
    "view_recipients_stock", //Voir la liste des allocataires stock [DONE]
    "modify_constants", //Modifier les constantes dynamiques [DONE]
    "crud_operateurs", //CRUD opérateurs [DONE]
    "crud_themes", //CRUD thèmes [DONE]
    "use_simulator", //Faire une simulation [DONE]
    "create_simulator_rdsp", //Assigner le résultat d'une simulation à un allocataire [DONE]
    "modify_rdsp", //modifier un RDO [DONE]
    "create_rdsp", //créer un RDO [DONE]
    "cron_anomaly", //lancer le cron des anomalies [DONE]
    "file_exchange", //gérer les échanges de fichiers plats [DONE]
    "view_sites", //Voir la liste des site (pour CSU uniquement)
    "view_rdsp", //voir les RDO d'un allocataire
    "view_stats", //voir les stats
    "create_recipient", //créer un allocataire
    "view_passorientation", //voir le passorientation
    "export_csv", //exporter des données en csv
    "remove_anomaly", //supprimer une anomalie [DONE]
    "view_sectors", //voir et éditer les secteurs,
    "view_ep_calendar",
    "create_recipient_ep", //créer un alloc man. pour EP
    "finalize_ep", //"finaliser une EP"
    "modify_epdetails", //modifier les paramètres d'un EP
    "manage_ep_invitations",
    "crud_reorientations",
    "crud_cer",
    "view_cer_list",
    "view_recipient_stock", //voir la liste des alloc du stock
    "export_recipient_stock", //exporter la liste des alloc du stock
    "view_regles_orientation", //Voir les règles de sous-orientation (ADMIN et SUPER_ADMIN uniquement, CE-1419)
    "edit_regles_orientation", //Saisir les règles de sous-orientation (SUPER_ADMIN uniquement, CE-1419)
  ],
  MANAGER_PARTNER: [
    "delete_exports", //Supprimer manuellement un export (SUPER_ADMIN uniquement)
    "crud_organizations", //CRUD les organisations [DONE]
    "crud_sites", //CRUD les sites [DONE]
    "view_site_calendar", //Voir les calendriers des sites [DONE]
    "crud_event_calendar", //CRUD les évènements sur les calendrier des sites [DONE]
    "view_anomalies", //Voir les anomalies [DONE]
    "manage_anomalies", //Voir mes anomalies [DONE]
    "update_recipients", //Modifier les infos des allocataires [DONE]
    "unlock_recipient", //Débloquer le compte [DONE]
    "resend_recipient_activation", //Renvoyer le lien d'activation [DONE]
    "view_recipient_appointments", //Voir les RDV allocataire
    "report_recipient_appointments", //Reporter les RDVS des allocataires [DONE]
    "view_recipients_temp", //Voir la liste des allocataires [DONE]
    "view_recipients_stock", //Voir la liste des allocataires stock [DONE]
    "send_rdsp_link", //Envoyer le lien de la RDO [DONE]
    "crud_users", //CRUD utilisateur [DONE]
    "view_imports", //Voir le suivi des imports [DONE]
    "view_sanctions_ft", //Voir les propositions de sanction France Travail [DONE]
    "view_exports", //Voir le suivi des exports et en demander [DONE]
    "download_exports", //Télécharger le fichier d'un export [DONE]

    "modify_constants", //Modifier les constantes dynamiques [DONE]
    "crud_operateurs", //CRUD opérateurs [DONE]
    "crud_themes", //CRUD thèmes [DONE]
    "use_simulator", //Faire une simulation [DONE]
    "create_simulator_rdsp", //Assigner le résultat d'une simulation à un allocataire [DONE]
    "modify_rdsp", //modifier un RDO [DONE]
    "create_rdsp", //créer un RDO [DONE]
    "cron_anomaly", //lancer le cron des anomalies [DONE]
    "file_exchange", //gérer les échanges de fichiers plats [DONE]
    "view_sites", //Voir la liste des site (pour CSU uniquement)

    "create_recipient", //créer un allocataire
    "view_passorientation", //voir le passorientation
    "remove_anomaly", //supprimer une anomalie [DONE]
    "edit_ep", //voir et éditer les EP
    "view_sectors", //voir et éditer les secteurs,

    "finalize_ep", //"finaliser une EP"
    "modify_epdetails", //modifier les paramètres d'un EP
    "manage_ep_invitations",
    "download_ar_mail",
    "crud_cer",
    "view_cer_list",
    "export_recipient_stock", //exporter la liste des alloc du stock
    "view_regles_orientation", //Voir les règles de sous-orientation (ADMIN et SUPER_ADMIN uniquement, CE-1419)
    "edit_regles_orientation", //Saisir les règles de sous-orientation (SUPER_ADMIN uniquement, CE-1419)
    "view_sous_orientation", //Voir la sous-orientation du dossier (agents Caf, encadrement, administrateurs, CE-1370)
  ],
  AGENT_PARTNER: [
    "delete_exports", //Supprimer manuellement un export (SUPER_ADMIN uniquement)
    "crud_organizations", //CRUD les organisations [DONE]
    "crud_sites", //CRUD les sites [DONE]
    "view_site_calendar", //Voir les calendriers des sites [DONE]
    "crud_event_calendar", //CRUD les évènements sur les calendrier des sites [DONE]
    "update_recipients", //Modifier les infos des allocataires [DONE]
    "unlock_recipient", //Débloquer le compte [DONE]
    "resend_recipient_activation", //Renvoyer le lien d'activation [DONE]
    "view_recipient_appointments", //Voir les RDV allocataire
    "report_recipient_appointments", //Reporter les RDVS des allocataires [DONE]
    "view_recipients_temp", //Voir la liste des allocataires [DONE]
    "view_recipients_stock", //Voir la liste des allocataires stock [DONE]
    "send_rdsp_link", //Envoyer le lien de la RDO [DONE]
    "crud_users", //CRUD utilisateur [DONE]
    "view_imports", //Voir le suivi des imports [DONE]
    "view_sanctions_ft", //Voir les propositions de sanction France Travail [DONE]
    "view_exports", //Voir le suivi des exports et en demander [DONE]
    "download_exports", //Télécharger le fichier d'un export [DONE]
    "view_anomalies", //Voir les anomalies [DONE]
    "manage_anomalies", //Voir mes anomalies [DONE]
    "assign_anomaly", //Assigner une anomalie [DONE]
    "modify_constants", //Modifier les constantes dynamiques [DONE]
    "crud_operateurs", //CRUD opérateurs [DONE]
    "crud_themes", //CRUD thèmes [DONE]
    "use_simulator", //Faire une simulation [DONE]
    "create_simulator_rdsp", //Assigner le résultat d'une simulation à un allocataire [DONE]
    "modify_rdsp", //modifier un RDO [DONE]
    "create_rdsp", //créer un RDO [DONE]
    "cron_anomaly", //lancer le cron des anomalies [DONE]
    "file_exchange", //gérer les échanges de fichiers plats [DONE]
    "view_sites", //Voir la liste des site (pour CSU uniquement)

    "create_recipient", //créer un allocataire
    "view_passorientation", //voir le passorientation
    "remove_anomaly", //supprimer une anomalie [DONE]
    "edit_ep", //voir et éditer les EP
    "view_sectors", //voir et éditer les secteurs,

    "finalize_ep", //"finaliser une EP"
    "modify_epdetails", //modifier les paramètres d'un EP
    "manage_ep_invitations",
    "download_ar_mail",
    "crud_cer",
    "view_cer_list",
    "export_recipient_stock", //exporter la liste des alloc du stock
    "view_regles_orientation", //Voir les règles de sous-orientation (ADMIN et SUPER_ADMIN uniquement, CE-1419)
    "edit_regles_orientation", //Saisir les règles de sous-orientation (SUPER_ADMIN uniquement, CE-1419)
    "view_sous_orientation", //Voir la sous-orientation du dossier (agents Caf, encadrement, administrateurs, CE-1370)
  ],
  SECRETARY_EP: [
    "delete_exports", //Supprimer manuellement un export (SUPER_ADMIN uniquement)
    "crud_organizations", //CRUD les organisations [DONE]
    "crud_sites", //CRUD les sites [DONE]
    "view_site_calendar", //Voir les calendriers des sites [DONE]
    "crud_event_calendar", //CRUD les évènements sur les calendrier des sites [DONE]
    "view_recipients", //Voir la liste des allocataires [DONE]
    "update_recipients", //Modifier les infos des allocataires [DONE]
    "unlock_recipient", //Débloquer le compte [DONE]
    "resend_recipient_activation", //Renvoyer le lien d'activation [DONE]
    "report_recipient_appointments", //Reporter les RDVS des allocataires [DONE]
    "view_recipients_temp", //Voir la liste des allocataires temporaires [DONE]
    "view_recipients_stock", //Voir la liste des allocataires stock [DONE]
    "send_rdsp_link", //Envoyer le lien de la RDO [DONE]
    "crud_users", //CRUD utilisateur [DONE]
    "view_imports", //Voir le suivi des imports [DONE]
    "view_sanctions_ft", //Voir les propositions de sanction France Travail [DONE]
    "view_exports", //Voir le suivi des exports et en demander [DONE]
    "download_exports", //Télécharger le fichier d'un export [DONE]
    "manager_appointments", //Traiter des rendez-vous [DONE]
    "view_anomalies", //Voir les anomalies [DONE]
    "assign_anomaly", //Assigner une anomalie [DONE]
    "manage_anomalies", //Voir et traiter mes anomalies [DONE]
    "modify_constants", //Modifier les constantes dynamiques [DONE]
    "crud_operateurs", //CRUD opérateurs [DONE]
    "crud_themes", //CRUD thèmes [DONE]
    "use_simulator", //Faire une simulation [DONE]
    "create_simulator_rdsp", //Assigner le résultat d'une simulation à un allocataire [DONE]
    "modify_rdsp", //modifier un RDO [DONE]
    "create_rdsp", //créer un RDO [DONE]
    "cron_anomaly", //lancer le cron des anomalies [DONE]
    "file_exchange", //gérer les échanges de fichiers plats [DONE]
    "view_sites", //Voir la liste des site (pour CSU uniquement)
    "view_rdsp", //voir les RDO d'un allocataire
    "view_stats", //voir les stats
    "create_recipient", //créer un allocataire
    "view_passorientation", //voir le passorientation
    "export_csv", //exporter des données en csv
    "remove_anomaly", //supprimer une anomalie [DONE]
    "crud_reorientations", //liste des réorientations en cours
    "crud_cer",
    "view_cer_list",
    "export_recipient_stock", //exporter la liste des alloc du stock
    "view_regles_orientation", //Voir les règles de sous-orientation (ADMIN et SUPER_ADMIN uniquement, CE-1419)
    "edit_regles_orientation", //Saisir les règles de sous-orientation (SUPER_ADMIN uniquement, CE-1419)
    "view_sous_orientation", //Voir la sous-orientation du dossier (agents Caf, encadrement, administrateurs, CE-1370)
  ],
  ADMIN_OPERATEUR: [...privilegesMasquesOperateur],
  MANAGEUR_OPERATEUR: [...privilegesMasquesOperateur],
  AGENT_OPERATEUR: [...privilegesMasquesOperateur],
};

export default roleConfig;
